import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useRef, useState, useEffect } from 'react';

function useUncontrolled(_ref) {
  var value = _ref.value,
      defaultValue = _ref.defaultValue,
      finalValue = _ref.finalValue,
      rule = _ref.rule,
      onChange = _ref.onChange,
      onValueUpdate = _ref.onValueUpdate;
  var shouldBeControlled = rule(value);
  var modeRef = useRef("initial");
  var initialValue = rule(defaultValue) ? defaultValue : finalValue;

  var _useState = useState(initialValue),
      _useState2 = _slicedToArray(_useState, 2),
      uncontrolledValue = _useState2[0],
      setUncontrolledValue = _useState2[1];

  var effectiveValue = shouldBeControlled ? value : uncontrolledValue;

  if (!shouldBeControlled && modeRef.current === "controlled") {
    effectiveValue = finalValue;
  }

  modeRef.current = shouldBeControlled ? "controlled" : "uncontrolled";
  var mode = modeRef.current;

  var handleChange = function handleChange(nextValue) {
    typeof onChange === "function" && onChange(nextValue);

    if (mode === "uncontrolled") {
      setUncontrolledValue(nextValue);
    }
  };

  useEffect(function () {
    if (mode === "uncontrolled") {
      setUncontrolledValue(effectiveValue);
    }

    typeof onValueUpdate === "function" && onValueUpdate(effectiveValue);
  }, [mode, effectiveValue]);
  return [effectiveValue, handleChange, modeRef.current];
}

export { useUncontrolled };